import { styled } from '@linaria/react';
import { semantic, space } from '../../theme/tokens';

export const Card = styled.div`
  background: ${semantic.bg.canvas};
  border: 1px solid ${semantic.border.subtle};
  border-radius: 12px;
  padding: ${space['space-600']};
`;
